import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    role: '',
    email: '',
    password: '',
    rememberMe: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const roleOptions = [
    { value: 'director', label: 'Direktur' },
    { value: 'consultant', label: 'Konsultan' },
    { value: 'management', label: 'Manajemen' }
  ];

  const mockCredentials = {
    director: { email: 'direktur@isuka.co.id', password: 'Direktur2026!' },
    consultant: { email: 'konsultan@isuka.co.id', password: 'Konsultan2026!' },
    management: { email: 'manajemen@isuka.co.id', password: 'Manajemen2026!' }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.role) {
      newErrors.role = 'Silakan pilih peran Anda';
    }

    if (!formData?.email) {
      newErrors.email = 'Email wajib diisi';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Format email tidak valid';
    }

    if (!formData?.password) {
      newErrors.password = 'Password wajib diisi';
    } else if (formData?.password?.length < 8) {
      newErrors.password = 'Password minimal 8 karakter';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);

    setTimeout(() => {
      const credentials = mockCredentials?.[formData?.role];
      
      if (formData?.email === credentials?.email && formData?.password === credentials?.password) {
        navigate('/company-profile-form');
      } else {
        setErrors({
          submit: `Email atau password salah. Gunakan kredensial berikut:\nEmail: ${credentials?.email}\nPassword: ${credentials?.password}`
        });
      }
      
      setIsLoading(false);
    }, 1500);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  return (
    <div className="w-full max-w-md">
      <div className="bg-card rounded-xl shadow-lg border border-border p-8 md:p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
            <Icon name="Milk" size={40} color="var(--color-primary)" />
          </div>
          <h1 className="text-2xl md:text-3xl font-semibold text-center mb-2">
            I_SUKA DueDiligence
          </h1>
          <p className="text-sm md:text-base text-muted-foreground text-center">
            Sistem Analisis Risiko Berbasis AI untuk Industri Susu
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <Select
            label="Peran Pengguna"
            placeholder="Pilih peran Anda"
            options={roleOptions}
            value={formData?.role}
            onChange={(value) => handleInputChange('role', value)}
            error={errors?.role}
            required
          />

          <Input
            label="Email"
            type="email"
            placeholder="nama@perusahaan.co.id"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={errors?.email}
            required
          />

          <div className="relative">
            <Input
              label="Password"
              type={showPassword ? 'text' : 'password'}
              placeholder="Masukkan password Anda"
              value={formData?.password}
              onChange={(e) => handleInputChange('password', e?.target?.value)}
              error={errors?.password}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-[38px] text-muted-foreground hover:text-foreground transition-colors"
              aria-label={showPassword ? 'Sembunyikan password' : 'Tampilkan password'}
            >
              <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
            </button>
          </div>

          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={formData?.rememberMe}
                onChange={(e) => handleInputChange('rememberMe', e?.target?.checked)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
              />
              <span className="text-sm text-foreground">Ingat Saya</span>
            </label>
            <button
              type="button"
              className="text-sm text-primary hover:text-primary/80 transition-colors font-medium"
            >
              Lupa Password?
            </button>
          </div>

          {errors?.submit && (
            <div className="bg-error/10 border border-error/20 rounded-lg p-4">
              <div className="flex gap-3">
                <Icon name="AlertCircle" size={20} color="var(--color-error)" className="flex-shrink-0 mt-0.5" />
                <p className="text-sm text-error whitespace-pre-line">{errors?.submit}</p>
              </div>
            </div>
          )}

          <Button
            type="submit"
            variant="default"
            size="lg"
            fullWidth
            loading={isLoading}
            iconName="LogIn"
            iconPosition="right"
          >
            Masuk ke Sistem
          </Button>
        </form>

        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-xs text-center text-muted-foreground">
            Dengan masuk, Anda menyetujui{' '}
            <button className="text-primary hover:text-primary/80 font-medium">
              Syarat & Ketentuan
            </button>{' '}
            dan{' '}
            <button className="text-primary hover:text-primary/80 font-medium">
              Kebijakan Privasi
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;